export const SuccessMessages = {
  fileUpload: {
    id: 'lease-document-wizard.file-field.message.success',
    defaultMessage: 'File Successfully Uploaded',
  },
  registration: {
    id: 'phrase.register.success',
    defaultMessage: 'Registration successful!',
  },
  registrationCheckEmail: {
    id: 'phrase.register.success-check-email',
    defaultMessage: 'Registration successful!',
  },
  verification: {
    id: 'phrase.verification.success',
    defaultMessage: 'Your email has been verified',
  },
  archiveDeal: {
    id: 'phrase.deal.archived.success',
    defaultMessage: 'Deal successfully archived',
  },
  unarchiveDeal: {
    id: 'phrase.deal.unarchived.success',
    defaultMessage: 'Deal successfully unarchived',
  },
  deactivateTemplate: {
    id: 'phrase.template.deactivated.success',
    defaultMessage: 'Template successfully deactivated',
  },
  deactivateClause: {
    id: 'phrase.clause.deactivated.success',
    defaultMessage: 'Clause successfully deactivated',
  },
  activateTemplate: {
    id: 'phrase.template.activated.success',
    defaultMessage: 'Template successfully activated',
  },
  activateClause: {
    id: 'phrase.clause.activated.success',
    defaultMessage: 'Clause successfully activated',
  },
};
